export default "__VITE_ASSET___oGGpYsj__"